module.exports = __webpack_public_path__ + "img/pro3.2d8cc3e1.png";